import { render, staticRenderFns } from "./AppBottomNav.vue?vue&type=template&id=58a81d8d&"
import script from "./AppBottomNav.vue?vue&type=script&lang=js&"
export * from "./AppBottomNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports